import React from 'react';
import { Link } from 'react-router-dom';
import { BrandLogo } from './BrandLogo';
import { primaryNav } from '../../data/navigation';
import { siteConfig } from '../../data/siteConfig';
import { useAnchorNavigation } from '../../hooks/useAnchorNavigation';
export function SiteFooter() {
  const goTo = useAnchorNavigation();
  const {
    support
  } = siteConfig;
  return (
    // Extra bottom padding keeps the review indicator clear of footer content.
    <footer className="border-t border-line bg-canvas pb-28" data-id="element-293" data-mp="1lmccvftbvw7a">
      <div className="mx-auto grid max-w-page gap-12 px-5 pt-16 md:grid-cols-[1.4fr_1fr_1.2fr] md:px-10" data-id="element-294" data-mp="1qmgtr6y5esy1">
        <div data-id="element-295" data-mp="1cmz3so9499n3">
          <BrandLogo showUrl className="w-64 max-w-full" data-id="element-296" data-mp="1cnh90adray75" />
        </div>

        <nav aria-label="Footer" data-id="element-297" data-mp="1goayh86ukl25">
          <h2 className="text-[13px] font-semibold text-ink" data-id="element-298" data-mp="1grf8wnawod19">Explore</h2>
          <ul className="mt-3" data-id="element-299" data-mp="17sn7mc8o57x">
            {primaryNav.map(item => <li key={item.label} data-id="element-300" data-mp="5afglrok5y78">
                {item.anchor ? <a href={`/#${item.anchor}`} onClick={goTo(item.anchor)} className="inline-flex min-h-[44px] items-center text-[15px] text-ink-muted hover:text-ink" data-id="element-301" data-mp="1xvh0mqgvwazo">
                    {item.label}
                  </a> : <Link to={item.to ?? '/'} className="inline-flex min-h-[44px] items-center text-[15px] text-ink-muted hover:text-ink" data-id="element-302" data-mp="22ubsehwtx9vx">
                    {item.label}
                  </Link>}
              </li>)}
          </ul>
        </nav>

        <div data-id="element-303" data-mp="2qjmlrebuo201">
          <h2 className="text-[13px] font-semibold text-ink" data-id="element-304" data-mp="2qjcwjsympyve">Support</h2>
          <a href={support.phoneHref} className="mt-3 inline-flex min-h-[44px] items-center font-display text-2xl text-ink hover:text-bronze-deep" data-id="element-305" data-mp="2lme1n8755nw5">
            {support.phone}
          </a>
          <dl className="mt-2 space-y-1 text-[14px] text-ink-muted" data-id="element-306" data-mp="2unkhrg5vowov">
            {support.hours.map(h => <div key={h.days} className="flex justify-between gap-4 sm:justify-start" data-id="element-307" data-mp="1s6icrx47y9za">
                <dt className="sm:w-36" data-id="element-308" data-mp="1x5bszxaw4f35">{h.days}</dt>
                <dd data-id="element-309" data-mp="218rkkf83rp8z">{h.time}</dd>
              </div>)}
          </dl>
          <p className="mt-2 text-[13px] text-ink-muted" data-id="element-310" data-mp="25zhu84nkae9h">All times {support.timezone}.</p>
        </div>
      </div>
      <div className="mx-auto mt-14 max-w-page px-5 md:px-10" data-id="element-311" data-mp="2azmapuogz8zp">
        <p className="border-t border-line pt-6 text-[13px] text-ink-muted" data-id="element-312" data-mp="2b1725bfhmbtc">
          © 2026 {siteConfig.brandName}. {siteConfig.siteName}
        </p>
      </div>
    </footer>
  );
}